const selector = {
    videoPlayer: '#videoPlayer',
    imagePlayer: '#imagePlayer',
    cameraCard: '.camera-card',
    videoModal: '#videoModal',
};

export { selector };